import classNames from 'classnames';
import he from 'he';
import React from 'react';

const ProgressWithIcon = ({ icon, title, shortFall, goal }) => {
  return <div id='progress-with-icon' className={classNames('flexbox center align-center', { noProgress: shortFall === 0 })}>
    <div id='progress' className='flexbox center align-center'>
      <div id='progress-number'>
        {`${shortFall} `}
      </div>
      <div id='progress-text'>
        hrs left
      </div>
    </div>
    <img className="category-icon" src={he.decode(icon)} alt={title} />
  </div>
}

export default ProgressWithIcon;



// WEBPACK FOOTER //
// ./src/containers/partials/progress-with-icon.js